"use strict";

const _ = require('lodash');
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./GridCellRenderer");

class GridCellComponent extends EventEmitter {

    constructor(configOptions) {
        super();

        this._id = _.get(configOptions, 'id', undefined);
        this._value = _.get(configOptions, 'value', undefined);
        this._columnRendererComponent = _.get(configOptions, 'columnRendererComponent');
        this._centralColumn = _.get(configOptions, 'centralColumn');
        this._width = _.get(configOptions, 'width', undefined);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer._shutdown()
            .then(()=>{
                this._renderer = undefined;
                this._id = undefined;
                this._value = undefined;
                this._columnRendererComponent = undefined;
                this._centralColumn = undefined;
                this._width = undefined;
            });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _triggerCellAction(eventData){
        this.emit('CellAction', eventData);
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    getColumnRendererComponent(){
        return this._columnRendererComponent;
    }

    setId(newVal){
        this._id = newVal;
        this.emit('ID', this._id);
        return this;
    }
    getId(){
        return this._id;
    }

    setCentralColumn(newVal){
        this._centralColumn = newVal;
        this.emit('CentralColumn', this._centralColumn);
        return this;
    }
    getCentralColumn(){
        return this._centralColumn;
    }

    setValue(newVal){
        this._value = newVal;
        this.emit('Value', this._value);
        return this;
    }
    getValue(){
        return this._value;
    }

    setWidth(newVal){
        this._width = newVal;
        this.emit('Width', this._width);
        return this;
    }
    getWidth(){
        return this._width;
    }
    
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = GridCellComponent;